import Deselect from './Deselect.vue'
import OpenIndicator from './OpenIndicator.vue'

export default {
  Deselect,
  OpenIndicator,
}



// WEBPACK FOOTER //
// webpack://VueSelect/src/components/childComponents.js